import React from 'react';
import { USD } from 'helpers/formatters/number_formats';

type Props = {
  centered?: boolean;
  estimatedValue?: number;
  hideSubtitle?: boolean;
  listingValue?: number;
  shortSubtitle?: boolean;
  valueClass?: string;
}

export default function PropertyPrice({
  centered,
  estimatedValue,
  hideSubtitle,
  listingValue,
  shortSubtitle,
  valueClass,
}: Props) {
  const useEstimated = !(listingValue && listingValue !== 0);
  const valueForDisplay = listingValue || estimatedValue;

  if (!valueForDisplay) return null;

  return (
    <div className={`d-flex flex-column gap-1 ${centered ? 'align-items-center' : 'align-items-baseline'}`}>
      <span className={`my-0 ${valueClass}`}>
        {USD.format(valueForDisplay, { round: true })}
      </span>
      {!hideSubtitle && useEstimated && (
        <div className="text-xs text-muted">
          Est. {!shortSubtitle && 'Value'}
        </div>
      )}
    </div>
  );
}
